import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "sourceIdInput", "titleInput", "channelInput", "dropdown", "checkmark"]

  connect() {
    this.timeout = null
    this.minLength = 0
    this.debounceDelay = 500
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search() {
    const query = this.inputTarget.value.trim()

    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, this.debounceDelay)
  }

  performSearch(query, showDropdownAfter = true) {
    const selectedId = this.hasSourceIdInputTarget ? this.sourceIdInputTarget.value : ''
    const frameId = this.inputTarget.dataset.turboFrame || this.getFrameId()
    const url = `${this.inputTarget.dataset.url}?q=${query}&selected_id=${selectedId}`

    if (showDropdownAfter) {
      this.showDropdown()
    }

    fetch(`${url}&frame=${frameId}`, {
      headers: { 'Accept': 'text/vnd.turbo-stream.html' }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
      .catch(error => {
        console.error('Search failed:', error)
        this.hideDropdown()
      })
  }

  select(event) {
    const value = event.params.value
    const display = event.params.display
    const sourceId = event.params.sourceId
    const title = event.params.title
    const channel = event.params.channel

    this.inputTarget.value = display

    if (this.hasSourceIdInputTarget) this.sourceIdInputTarget.value = sourceId || ''
    if (this.hasTitleInputTarget) this.titleInputTarget.value = title || ''
    if (this.hasChannelInputTarget) this.channelInputTarget.value = channel || ''

    this.checkmarkTargets.forEach(icon => icon.classList.add('hidden'))

    const selectedCheckmark = event.currentTarget.querySelector('[data-combobox-target="checkmark"]')
    if (selectedCheckmark) {
      selectedCheckmark.classList.remove('hidden')
    }

    this.hideDropdown()
  }

  toggle() {
    if (this.hasDropdownTarget) {
      if (this.dropdownTarget.classList.contains('hidden')) {
        this.showDropdown()
      } else {
        this.hideDropdown()
      }
    }
  }

  show() {
    this.performSearch('')
    this.showDropdown()
  }

  hide() {
    setTimeout(() => {
      this.hideDropdown()
    }, 150)
  }

  showDropdown() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.remove('hidden')
    }
  }

  hideDropdown() {
    if (this.hasDropdownTarget) {
      this.dropdownTarget.classList.add('hidden')
    }
  }

  getFrameId() {
    const frame = this.element.querySelector('turbo-frame')
    return frame ? frame.id : 'ticket_combobox_frame'
  }

}
